import { call, put, takeLatest, all, fork } from 'redux-saga/effects';

// Dashboard Redux States
import {
	TOTAL_WEEK_SHIPMENT_LOADING,
	GET_LOADING_BOOKINGS_LOADING_DATA,
	TOTAL_YEAR_SHIPMENT_LOADING,
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING,
	GET_CHART_DATA_LOADING,
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING,
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING,
	GET_ADVANCED_BOOKING_COUNT_LOADING,
	GET_SELECTED_TASKS_SCHEDULE
} from './actionTypes';
import {
	totalWeekShipmentData,
	totalWeekShipmentError,
	getLoadingBookingsData,
	getLoadingBookingsError,
	getTotalShipmentData,
	getTotalShipmentError,
	getTotalCurrentMonthShipmentData,
	getTotalCurrentMonthShipmentError,
	getChartsData,
	getChartsDataError,
	getBookingChartDataBasedOnSupplierLocationData,
	getBookingChartDataBasedOnSupplierLocationError,
	getContainerCountsBasedOnBookingStatusData,
	getContainerCountsBasedOnBookingStatusError,
	getAdvancedBookingCountData,
	getAdvancedBookingCountError,
	setSelectedTaskSchedule
} from './actions';

//Include Both Helper File with needed methods
import {
	getLoadingBookingsDataAPI,
	getarrivalanddepartureDataAPI,
	getTotalShipmentCountBasedOnYearAPI,
	getTotalShipmentCountBasedOnCurrentMonthAPI,
	getChartDataBasedOnContainerOrBookingsAPI,
	getChartDataBasedOnSupplierLocationAPI,
	getContainerCountsBasedOnBookingStatusAPI,
	getAdvancedBookingCountDataAPI
} from './helper';
import moment from 'moment/moment';

// function* getChartsData({ payload: periodType }) {
//     try {
//         var response;
//         if (periodType == "monthly") {
//             response = yield call(getWeeklyData, periodType);
//         }
//         if (periodType == "yearly") {
//             response = yield call(getYearlyData, periodType);
//         }
//         if (periodType == "weekly") {
//             response = yield call(getMonthlyData, periodType);
//         }

//         yield put(apiSuccess(GET_CHARTS_DATA, response));
//     } catch (error) {
//         yield put(apiFail(GET_CHARTS_DATA, error));
//     }
// }

function* getArrivalAndDpartureData() {
	try {
		var response = yield call(getarrivalanddepartureDataAPI);
		yield put(totalWeekShipmentData(response));
	} catch (error) {
		yield put(totalWeekShipmentError(error));
	}
}

function* getTodaysLoadingBookingsData({ payload }) {
	try {
		let todaysDate = moment(new Date(payload)).format('DD-MM-YYYY');
		var response = yield call(getLoadingBookingsDataAPI, { inputDate: todaysDate });
		yield put(getLoadingBookingsData(response));
	} catch (error) {
		yield put(getLoadingBookingsError(error));
	}
}

function* getTotalShipmentDataBasedOnYear({ payload }) {
	try {
		var response = yield call(getTotalShipmentCountBasedOnYearAPI, payload);
		yield put(getTotalShipmentData(response));
	} catch (error) {
		yield put(getTotalShipmentError(error));
	}
}

function* getTotalShipmentDataBasedOnCurrentMonth({ payload }) {
	try {
		var response = yield call(getTotalShipmentCountBasedOnCurrentMonthAPI, payload);
		yield put(getTotalCurrentMonthShipmentData(response));
	} catch (error) {
		yield put(getTotalCurrentMonthShipmentError(error));
	}
}

function* getBookingAndContainerChartsData({ payload }) {
	try {
		let response = yield call(getChartDataBasedOnContainerOrBookingsAPI, { ...payload });
		yield put(getChartsData(response));
	} catch (error) {
		yield put(getChartsDataError(error));
	}
}

function* getBookingChartDataBasedOnSupplierLocationDataset(payload) {
	try {
		let month = payload?.payload;
		let response = yield call(getChartDataBasedOnSupplierLocationAPI, { month });
		yield put(getBookingChartDataBasedOnSupplierLocationData(response?.bookingData || []));
	} catch (error) {
		yield put(getBookingChartDataBasedOnSupplierLocationError(error));
	}
}

function* getContainerCountsBasedOnBookingStatus(payload) {
	try {
		let year = payload?.payload;
		let response = yield call(getContainerCountsBasedOnBookingStatusAPI, { year });
		yield put(getContainerCountsBasedOnBookingStatusData(response?.output || []));
	} catch (error) {
		yield put(getContainerCountsBasedOnBookingStatusError(error));
	}
}

function* getAdvancedBookingCountStats() {
	try {
		let response = yield call(getAdvancedBookingCountDataAPI);
		yield put(getAdvancedBookingCountData(response?.bookingData || []));
	} catch (error) {
		yield put(getAdvancedBookingCountError(error));
	}
}

function* updatSelectedTaskSchedule({ payload }) {
	yield put(setSelectedTaskSchedule(payload));
}

function* watchAllDashboardEndpoints() {
	yield takeLatest(TOTAL_WEEK_SHIPMENT_LOADING, getArrivalAndDpartureData);
	yield takeLatest(GET_LOADING_BOOKINGS_LOADING_DATA, getTodaysLoadingBookingsData);
	yield takeLatest(TOTAL_YEAR_SHIPMENT_LOADING, getTotalShipmentDataBasedOnYear);
	yield takeLatest(GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING, getTotalShipmentDataBasedOnCurrentMonth);
	yield takeLatest(GET_CHART_DATA_LOADING, getBookingAndContainerChartsData);
	yield takeLatest(
		GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING,
		getBookingChartDataBasedOnSupplierLocationDataset
	);
	yield takeLatest(GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING, getContainerCountsBasedOnBookingStatus);
	yield takeLatest(GET_ADVANCED_BOOKING_COUNT_LOADING, getAdvancedBookingCountStats);
	yield takeLatest(GET_SELECTED_TASKS_SCHEDULE, updatSelectedTaskSchedule);
}

function* dashboardSaga() {
	yield all([fork(watchAllDashboardEndpoints)]);
}

export default dashboardSaga;
